import { createAction,props } from "@ngrx/store";
import { ProjectSessionRequest } from "../../models/SquirrelSession";


export enum ProjectSessionTypes {
    GetProjectSessionType = '[Project-Session] Success',
    InvokeApisTypes = '[[Project-Session] Invoke API'
}

export const getProjectSessionData = createAction(ProjectSessionTypes.GetProjectSessionType, props<{projectsessionreq:ProjectSessionRequest}>());
export const invokeApis = createAction(ProjectSessionTypes.InvokeApisTypes, props<{projectname:string}>());